var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 6.41667C10.5137 6.41667 10.0474 6.22351 9.70356 5.8797C9.35974 5.53588 9.16659 5.06956 9.16659 4.58333C9.16659 4.0971 9.35974 3.63079 9.70356 3.28697C10.0474 2.94315 10.5137 2.75 10.9999 2.75C11.4861 2.75 11.9525 2.94315 12.2963 3.28697C12.6401 3.63079 12.8333 4.0971 12.8333 4.58333C12.8333 5.06956 12.6401 5.53588 12.2963 5.8797C11.9525 6.22351 11.4861 6.41667 10.9999 6.41667ZM10.9999 12.8333C10.5137 12.8333 10.0474 12.6402 9.70356 12.2964C9.35974 11.9525 9.16659 11.4862 9.16659 11C9.16659 10.5138 9.35974 10.0475 9.70356 9.70364C10.0474 9.35982 10.5137 9.16667 10.9999 9.16667C11.4861 9.16667 11.9525 9.35982 12.2963 9.70364C12.6401 10.0475 12.8333 10.5138 12.8333 11C12.8333 11.4862 12.6401 11.9525 12.2963 12.2964C11.9525 12.6402 11.4861 12.8333 10.9999 12.8333ZM10.9999 19.25C10.5137 19.25 10.0474 19.0568 9.70356 18.713C9.35974 18.3692 9.16658 17.9029 9.16658 17.4167C9.16658 16.9304 9.35974 16.4641 9.70356 16.1203C10.0474 15.7765 10.5137 15.5833 10.9999 15.5833C11.4861 15.5833 11.9525 15.7765 12.2963 16.1203C12.6401 16.4641 12.8333 16.9304 12.8333 17.4167C12.8333 17.9029 12.6401 18.3692 12.2963 18.713C11.9525 19.0568 11.4861 19.25 10.9999 19.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDots);
export default __webpack_public_path__ + "static/media/menu-dots.8b73ff0b8cb434b673c483ddd066c98c.svg";
export { ForwardRef as ReactComponent };